import https from "../repositories/https";

export default {
  countryList() {
    return https.get(`countries.json`);
  },
  timezoneList() {
    return https.get(`timezones.json`);
  },
  stateList(country) {
    return https.get(`/countries/${country ? country : "IN"}/states.json`);
  },
};
